let inMemoryRefreshToken = null;
const isBrowser = () => typeof window !== 'undefined';
const get = () => {
    if (!isBrowser()) {
        return null;
    }
    return inMemoryRefreshToken;
};
const set = (token) => {
    if (!isBrowser()) {
        return;
    }
    const safeToken = token?.trim();
    if (!safeToken) {
        clear();
        return;
    }
    inMemoryRefreshToken = safeToken;
};
const clear = () => {
    if (!isBrowser()) {
        return;
    }
    inMemoryRefreshToken = null;
};
export const refreshTokenStorage = {
    get,
    set,
    clear,
};
